
import CarIcon from "@/components/icons/CarIcon.vue";
import WrenchIcon from "@/components/icons/WrenchIcon.vue";
import AssignmentIcon from "@/components/icons/AssignmentIcon.vue";
import SearchFileIcon from "@/components/icons/SearchFileIcon.vue";

import { defineComponent } from "vue";
export default defineComponent({
  components: { SearchFileIcon, AssignmentIcon, WrenchIcon, CarIcon },
});
